import { render, staticRenderFns } from "./PosEvents.vue?vue&type=template&id=3b586e38&"
import script from "./PosEvents.vue?vue&type=script&lang=js&"
export * from "./PosEvents.vue?vue&type=script&lang=js&"
import style0 from "./PosEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports